import React,{ useState, useEffect, useRef } from 'react';
import { ArrowLeftOutlined, ArrowRightOutlined  } from '@ant-design/icons';
import { useNavigate  } from 'react-router-dom';

import CardDom from '../CardDom/CardDom';
import BaseButton from '../BaseButton/BaseButton';

import './CarouselDom.less'

const CarouselDom = ({CarouselData}) =>{
  const carouselRef = useRef(null);
  const [width, setWidth] = useState(window.innerWidth);
  const [selectData, setSelectData] = useState(0)
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  
  
  useEffect(()=>{
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 设置初始宽度
    setWidth(window.innerWidth);
 
    // 监听窗口大小变化
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  },[])

  const handleTouchStart = (ev) => {
    setIsDragging(true);
    setStartX(ev.touches[0].clientX);
  };
 
  const handleTouchMove = (ev) => {
    if (!isDragging) return;
    const currentX = ev.touches[0].clientX;
    const diffX = currentX - startX;
    console.log(diffX)
    // 根据滑动距离来决定是否切换图片
    if (diffX > 50) {
      setSelectData((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : CarouselData.data.length - 1));
      setIsDragging(false);
    } else if (diffX < -50) {
      setSelectData((prevIndex) => (prevIndex < CarouselData.data.length - 1 ? prevIndex + 1 : 0));
      setIsDragging(false);
    }
  };
 
  const handleTouchEnd = () => {
    setIsDragging(false);
    // 在这里可以添加滑动结束后的逻辑，例如计算滑动的距离或速度等
  };
  

  if(width>770){
    return (
      <div style={{width: '100%', overflow: 'hidden'}}>
        <div className="Carousel-list-box">
          <div className="Carousel-list" ref={carouselRef} style={{left: ((width/4)/2-10) - (selectData*(width/4))}}>
            <div className="Carousel-item-box" style={CarouselData.data.length === 1? {width:'25vw'}:{}}>
              <div className="Carousel-item" style={{fontSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)'}}>
                {CarouselData.CarouselText}
                
                <BaseButton 
                  style={{cursor: 'pointer'}}
                  btnConfig={{
                    text: CarouselData.btnText,
                    icon: 'ArrowRightOutlined',
                    link: CarouselData.link
                  }}
                />
              </div>
            </div>
            {CarouselData.data.map((e,i)=>{
              return (
                <div key={i} className="Carousel-item-box" style={CarouselData.data.length === 1? {width:'25vw'}:{}}>
                  <div className="Carousel-item">
                    <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/>
                  </div>
                </div>
              )
            })}
          </div>
  
          <div className="Carousel-btn-box">
            {selectData === 0? 
              <div></div>
              :
              <div className="Carousel-btn" onClick={()=> setSelectData(selectData-1)}><ArrowLeftOutlined /></div>
            }
            
            {selectData === CarouselData.data.length-1? 
              <div></div>
              :
              <div className="Carousel-btn" onClick={()=> setSelectData(selectData+1)}><ArrowRightOutlined /></div>
            }
          </div>
        </div>
      </div>
    )
  }else{
   
    return (
      <div style={{width: '100%', overflow: 'hidden'}}>
        <div style={{fontSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)', padding: '0 25px', textAlign:'left'}}>
          {CarouselData.CarouselText}
        </div>

        <div className="Carousel-list-box" style={{marginBottom: 20}}>
          <div 
            className="Carousel-list-phone" 
            ref={carouselRef} 
            style={{left: 15-(selectData*(width*0.7))}}
            onTouchStart={(ev)=> handleTouchStart(ev)}
            onTouchMove={(ev)=> handleTouchMove(ev)}
            onTouchEnd={(ev)=> handleTouchEnd(ev)}
          >
            {CarouselData.data.map((e,i)=>{
              console.log(111111111,e)
              return (
                <div key={i} className="Carousel-item-box">
                  <div className="Carousel-item">
                    <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/>
                  </div>
                </div>
              )
            })}
          </div>
        </div>

        <div style={{padding: '0 25px'}}>
          <BaseButton 
            style={{width:'100%', margin: '40px 0'}}
            btnConfig={{
              text: CarouselData.btnText,
              icon: 'ArrowRightOutlined',
              link: CarouselData.link
            }}
          />
        </div>
      </div>
    )
  }
}

export default CarouselDom